import { render, staticRenderFns } from "./NewMenulistDetails.vue?vue&type=template&id=189a261a&scoped=true"
import script from "./NewMenulistDetails.vue?vue&type=script&lang=js"
export * from "./NewMenulistDetails.vue?vue&type=script&lang=js"
import style0 from "./NewMenulistDetails.vue?vue&type=style&index=0&id=189a261a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a261a",
  null
  
)

export default component.exports